import {__visit } from '../components/send-visit.js'


export function chartTracking (obj, subCategory = 'findSeat', category = 'bestAvailable', label = 'seat', value= '') {
  __visit({
    userId: obj.userId,
    siteId: obj.siteId,
    storeId: obj.storeId,
    eventId: obj.eventId,
    eventType: 'click',
    category,
    subCategory,
    label,
    value
  })

	console.info(`chartTracking: ${category} ${subCategory} `)
}

export function bvTracking (subCategory) {
  const userDetector = document.querySelector('[best-available-php-convert-to-js]')
  const obj = {
    userId: userDetector.getAttribute('data-userid'),
    siteId: userDetector.getAttribute('data-siteid'),
    storeId: userDetector.getAttribute('data-storeid'),
    eventId: userDetector.getAttribute('data-eventid')
  }
  chartTracking(obj, subCategory)
  console.info(`userDetector: ${userDetector}`)
}

window.bvTracking = bvTracking

